import { User, X } from "lucide-react";
import React from "react";

function ViewPatientDataByID({ viewPatientData, setViewPatientData }) {
  const patient = viewPatientData;

  return (
    <div className="fixed overflow-hidden inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={() => setViewPatientData(null)}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      />

      {/* Modal */}
      <div className="relative max-h-[calc(100%-80px)] overflow-y-auto bg-white w-[95%] max-w-3xl rounded-2xl shadow-2xl p-8">
        {/* Header */}
        <div className="relative flex items-center justify-between bg-gradient-to-r from-blue-200 to-white p-2 sm:p-6 rounded-2xl border border-gray-100 mb-6">
          <div className="flex items-center gap-5">
            {/* Avatar */}
            <div className="sm:w-24 sm:h-24 w-16 h-16 rounded-2xl overflow-hidden shadow-md border border-gray-200 bg-white flex items-center justify-center">
              {patient?.imageUrl ? (
                <img
                  src={patient.imageUrl}
                  alt="Patient"
                  className="w-full h-full object-cover"
                />
              ) : (
                <User className="w-10 h-10 text-blue-500" strokeWidth={1.8} />
              )}
            </div>

            {/* Name */}
            <div>
              <span className="text-xs uppercase tracking-widest text-gray-400 font-medium">
                Patient Details
              </span>
              <h2 className="text-3xl font-bold text-gray-800">
                {patient?.title} {patient?.name}
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                Branch ID: {patient?.hospitalBranchId}
              </p>
            </div>
          </div>

          {/* Close */}
          <button
            onClick={() => setViewPatientData(null)}
            className="absolute top-4 -right-4 sm:right-4 bg-white border border-gray-200 rounded-full p-2 text-gray-400 hover:text-red-500 transition"
          >
            <X className="w-5 h-5" strokeWidth={2} />
          </button>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
          <Info label="Email" value={patient?.email} />
          <Info label="Mobile" value={patient?.mobile} />
          <Info label="Gender" value={patient?.gender} />
          <Info
            label="Date of Birth"
            value={
              patient?.dob ? new Date(patient.dob).toLocaleDateString() : "-"
            }
          />

          <Info label="Address" value={patient?.address} />

          <div>
            <p className="text-gray-500">Status</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                patient?.isActive === 1
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {patient?.isActive === 1 ? "Active" : "Inactive"}
            </span>
          </div>

          <div>
            <p className="text-gray-500">Deleted</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                patient?.isDeleted === 1
                  ? "bg-red-100 text-red-600"
                  : "bg-blue-100 text-blue-700"
              }`}
            >
              {patient?.isDeleted === 1 ? "Yes" : "No"}
            </span>
          </div>

          {patient?.deactivatedAt && (
            <Info
              label="Deactivated At"
              value={new Date(patient.deactivatedAt).toLocaleString()}
            />
          )}

          {patient?.deletedAt && (
            <Info
              label="Deleted At"
              value={new Date(patient.deletedAt).toLocaleString()}
            />
          )}

          <Info
            label="Created At"
            value={new Date(patient?.created_at).toLocaleString()}
          />

          <Info
            label="Updated At"
            value={new Date(patient?.updated_at).toLocaleString()}
          />

          <div className="sm:col-span-2">
            <p className="text-gray-500">Patient UUID</p>
            <p className="font-mono text-xs text-gray-600 break-all">
              {patient?.id}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={() => setViewPatientData(null)}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

/* 🔹 Small reusable field component */
const Info = ({ label, value }) => (
  <div>
    <p className="text-gray-500">{label}</p>
    <p className="font-medium text-gray-800">{value || "-"}</p>
  </div>
);

export default ViewPatientDataByID;
